module.exports = __webpack_public_path__ + "img/moteamasu.956c0e5a.png";